import {getMessages} from '../../../../../store/constants';

export const USER_TOOLTIP_TITLE = getMessages().getText('user_tooltip.assignees.title');
export const USER_TOOLTIP_TITLE_SINGLE = getMessages().getText('user_tooltip.assignees.title_single');
export const USER_TOOLTIP_AUTHOR_TITLE_SINGLE = getMessages().getText('user_tooltip.author.title_single');
